import { render, staticRenderFns } from "./SoftwareComponentCommandsOverview.vue?vue&type=template&id=83848ada&"
import script from "./SoftwareComponentCommandsOverview.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentCommandsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports